import React, { useEffect, useState } from "react";
import { Timeline, Skeleton, Empty, Alert } from "antd";
import dayjs from "dayjs";

const CRMTimeLine = () => {
  const [activityData, setActivityData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const API_URL =
    "https://crmextapi.ibizaccounts.in/accumen/dashboard/GetActivity";

  const fetchActivities = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await fetch(API_URL);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data?.Status && Array.isArray(data?.ResultData)) {
        setActivityData(data.ResultData);
      } else {
        setActivityData([]);
      }
    } catch (err) {
      console.error("Error fetching activities:", err);
      setError("Failed to load activities.");
      setActivityData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActivities();
  }, []);

  // Loading skeleton
  if (loading) {
    return (
      <div className="crm-timeline">
        {[1, 2, 3, 4, 5].map((item) => (
          <div
            key={item}
            className="d-flex gap-3 mb-4"
            style={{ minHeight: "60px" }}
          >
            <div>
              <Skeleton.Avatar active size="small" shape="circle" />
            </div>

            <div className="flex-fill">
              <Skeleton
                active
                title={{ width: "45%" }}
                paragraph={{
                  rows: 2,
                  width: ["75%", "45%"],
                }}
              />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return <Alert message={error} type="error" showIcon />;
  }

  if (!activityData.length) {
    return <Empty description="No activities found" />;
  }

  const timelineItems = activityData.map((activity) => ({
    color: "green",

    children: (
      <div className="pb-2">
        {/* Activity */}
        <div className="fw-semibold text-dark">{activity.description_key}</div>

        {/* Project */}
        {activity.ProjectName && (
          <div className="text-muted small mt-1">
            <i className="ti ti-briefcase me-1" />
            {activity.ProjectName}
          </div>
        )}

        {/* Staff */}
        {activity.StaffName && (
          <div className="text-muted small mt-1">
            <i className="ti ti-user me-1" />
            {activity.StaffName}
          </div>
        )}

        {/* Date */}
        {activity.dateadded && (
          <div className="text-muted small mt-1">
            <i className="ti ti-calendar me-1" />
            {dayjs(activity.dateadded).format("DD/MM/YYYY hh:mm A")}
          </div>
        )}
      </div>
    ),
  }));

  return (
    <div className="crm-timeline">
      <Timeline items={timelineItems} />
    </div>
  );
};

export default CRMTimeLine;
